import React from 'react';
import './status-pill.css';

/**
 * Accessible subscription status pill.
 *
 * Meaning is carried by the TEXT LABEL (and a title), never by colour alone —
 * a dot + coloured background is decorative reinforcement only. Accepts either
 * the new `subscription_state` (active|trial|cancelled|free) or the legacy
 * `subscription_status` (Paid|Trial|Default), so it works during the API
 * transition.
 *
 * Props: { state, trialDays }
 */
const normalize = (raw) => {
  const v = String(raw ?? '').trim().toLowerCase();
  if (v === 'active' || v === 'paid') return 'active';
  if (v === 'trial') return 'trial';
  if (v === 'cancelled' || v === 'canceled') return 'cancelled';
  return 'free'; // '', 'default', 'free', unknown
};

const LABELS = {
  active: 'Active',
  trial: 'Trial',
  cancelled: 'Cancelled',
  free: 'Free',
};

const StatusPill = ({ state, trialDays }) => {
  const key = normalize(state);
  let label = LABELS[key];

  if (key === 'trial') {
    const days = Number(trialDays);
    if (Number.isFinite(days) && days > 0) label = `Trial · ${days}d left`;
    else if (Number.isFinite(days) && days <= 0) label = 'Trial ended';
  }

  return (
    <span
      className={`uv-pill uv-pill--${key}`}
      role="status"
      title={label}
      data-testid="status-pill"
      data-state={key}
    >
      <span className="uv-pill__dot" aria-hidden="true" />
      {label}
    </span>
  );
};

export default StatusPill;
